// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82c36f1e","239":"b8336827","732":"ff2fb935"}[chunkId] + ".chunk.js";
};